import { getCachedCollection } from './dataCacheService';
import { Holiday } from '../types';

export { type Holiday };

export const getHolidays = async (): Promise<Holiday[]> => {
  return await getCachedCollection<Holiday>('holidays');
};

export const getHolidayForDate = (date: string, holidays: Holiday[]): Holiday | null => {
  const d = new Date(date);
  return holidays.find(h => {
    const start = new Date(h.startDate);
    const end = new Date(h.endDate);
    return d >= start && d <= end;
  }) || null;
};

export const getHolidayActivitiesForDate = async (date: string): Promise<any[]> => {
  const { collection, query, where, getDocs } = await import('firebase/firestore');
  const { db } = await import('../firebase');
  const q = query(collection(db, 'holidayActivities'), where('date', '==', date));
  const snap = await getDocs(q);
  return snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};
